import { faInbox } from "@fortawesome/pro-light-svg-icons";
import { useEffect } from "react";

import { useT } from "@repo/transifex";
import { Tile, TileIcon } from "~/components/home/tile";
import { useToast } from "~/components/hooks/use-toast";
import { useOpenCashDrawer } from "~/hooks";
import { useCashDrawerStatus } from "~/providers/app/hooks";

type CashDrawerTileProps = {
  isTillOpen: boolean;
  isSessionValid: boolean;
};

export const CashDrawerTile = ({
  isTillOpen,
  isSessionValid
}: CashDrawerTileProps) => {
  const t = useT();
  const { toast } = useToast();
  const openCashDrawer = useOpenCashDrawer();
  const cashDrawerStatus = useCashDrawerStatus();

  useEffect(() => {
    if (cashDrawerStatus === "loading") {
      toast({
        title: t("Opening Cash Drawer"),
        description: t("Please wait"),
        duration: Infinity
      });
    }

    if (cashDrawerStatus === "open") {
      toast({
        title: t("Cash Drawer opened"),
        variant: "success",
        duration: 3000
      });
    }

    if (cashDrawerStatus === "error") {
      toast({
        title: t("Failed to open Cash Drawer"),
        variant: "destructive",
        duration: 3000
      });
    }
  }, [cashDrawerStatus, toast, t]);

  return (
    <Tile
      title={t("Open cash drawer")}
      disabled={
        !isTillOpen || !isSessionValid || cashDrawerStatus === "loading"
      }
      onClick={() => {
        openCashDrawer("manual");
      }}
      className="flex-1"
    >
      <TileIcon icon={faInbox} />
    </Tile>
  );
};
